module.exports = __webpack_public_path__ + "img/考试系统.71602964.svg";